define("auth/templates/application", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if (and this.model.isKeycloak this.isLoggingIn)}}
  
    <div class="tOB--container tSU--page">
    </div>
  
  {{else}}
    <div class="tOB--container tSU--page">
      {{! Navigation }}
      <div class="cHN--wrapper">
        <div class="cHN--container">
  
          <div class="u--row u--row--noCollapse">
            <div class="u--col__6">
              <div class="cHN--logoWrapper">
                {{! Logo }}
                <div class="cHN--logo">
                  <Shared::Link @href="https://later.com" @openInNewTab={{false}} title={{t "authorization.logo_title"}}>
                    <div class="img--logo"></div>
                  </Shared::Link>
                </div>
                {{! Page Title }}
                <h3 class="cHN--title">{{this.childRoutePageTitle}}</h3>
              </div>
            </div>
  
            <div class="u--col__6">
              <h3 class="cHN--action">
  
                {{#if this.isAuthenticated}}
                  <a class="u--p__l__xs" {{on "click" this.logout}}>
                    {{t "authorization.sign_up_header.sign_out"}}
                  </a>
                {{else if this.isCreatingAccount}}
                  {{! Log In }}
                  {{t "authorization.forgot_password.has_account"}}
                  {{#if this.isCampaign}}
                    <LinkTo @route="campaign.login" class="u--inline u--p__l__xs qa--logIn_header_link">
                      {{t "authorization.sign_in"}}
                    </LinkTo>
                  {{else}}
                    <LinkTo
                      @query={{this.searchParams}}
                      @route="login"
                      class="u--inline u--p__l__xs qa--logIn_header_link"
                    >
                      {{t "authorization.forgot_password.sign_in"}}
                    </LinkTo>
                  {{/if}}
                {{else if this.isResettingPassword}}
                  {{! Reset password from email }}
                  <LinkTo @route="login" class="u--inline u--p__l__xs">
                    {{t "reset_password.login"}}
                  </LinkTo>
                {{else}}
                  {{if
                    this.isSsoLogin
                    (t "authorization.new_to_later_sso" ssoAppName=this.ssoAppName)
                    (t "authorization.new_to_later")
                  }}
                  {{#if this.isCampaign}}
                    <LinkTo @route="campaign.signup" class="u--inline u--p__l__xs qa--createAccount_header_link">
                      {{html-safe (t "authorization.create_an_account")}}
                    </LinkTo>
                  {{else}}
                    <LinkTo
                      @query={{this.searchParams}}
                      @route="signup"
                      class="u--inline u--p__l__xs qa--createAccount_header_link"
                    >
                      {{html-safe (t "authorization.create_an_account")}}
                    </LinkTo>
                  {{/if}}
                {{/if}}
              </h3>
            </div>
          </div>
  
        </div>
      </div>
  
      {{outlet}}
  
    </div>
  {{/if}}
  */
  {
    "id": "0l37jwqP",
    "block": "[[[41,[28,[37,1],[[30,0,[\"model\",\"isKeycloak\"]],[30,0,[\"isLoggingIn\"]]],null],[[[1,\"\\n  \"],[10,0],[14,0,\"tOB--container tSU--page\"],[12],[1,\"\\n  \"],[13],[1,\"\\n\\n\"]],[]],[[[1,\"  \"],[10,0],[14,0,\"tOB--container tSU--page\"],[12],[1,\"\\n\"],[1,\"    \"],[10,0],[14,0,\"cHN--wrapper\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"cHN--container\"],[12],[1,\"\\n\\n        \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"u--col__6\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"cHN--logoWrapper\"],[12],[1,\"\\n\"],[1,\"              \"],[10,0],[14,0,\"cHN--logo\"],[12],[1,\"\\n                \"],[8,[39,2],[[16,\"title\",[28,[37,3],[\"authorization.logo_title\"],null]]],[[\"@href\",\"@openInNewTab\"],[\"https://later.com\",false]],[[\"default\"],[[[[1,\"\\n                  \"],[10,0],[14,0,\"img--logo\"],[12],[13],[1,\"\\n                \"]],[]]]]],[1,\"\\n              \"],[13],[1,\"\\n\"],[1,\"              \"],[10,\"h3\"],[14,0,\"cHN--title\"],[12],[1,[30,0,[\"childRoutePageTitle\"]]],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\\n          \"],[10,0],[14,0,\"u--col__6\"],[12],[1,\"\\n            \"],[10,\"h3\"],[14,0,\"cHN--action\"],[12],[1,\"\\n\\n\"],[41,[30,0,[\"isAuthenticated\"]],[[[1,\"                \"],[11,3],[24,0,\"u--p__l__xs\"],[4,[38,4],[\"click\",[30,0,[\"logout\"]]],null],[12],[1,\"\\n                  \"],[1,[28,[35,3],[\"authorization.sign_up_header.sign_out\"],null]],[1,\"\\n                \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isCreatingAccount\"]],[[[1,\"                \"],[1,[28,[35,3],[\"authorization.forgot_password.has_account\"],null]],[1,\"\\n\"],[41,[30,0,[\"isCampaign\"]],[[[1,\"                  \"],[8,[39,5],[[24,0,\"u--inline u--p__l__xs qa--logIn_header_link\"]],[[\"@route\"],[\"campaign.login\"]],[[\"default\"],[[[[1,\"\\n                    \"],[1,[28,[35,3],[\"authorization.sign_in\"],null]],[1,\"\\n                  \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"                  \"],[8,[39,5],[[24,0,\"u--inline u--p__l__xs qa--logIn_header_link\"]],[[\"@query\",\"@route\"],[[30,0,[\"searchParams\"]],\"login\"]],[[\"default\"],[[[[1,\"\\n                    \"],[1,[28,[35,3],[\"authorization.forgot_password.sign_in\"],null]],[1,\"\\n                  \"]],[]]]]],[1,\"\\n\"]],[]]]],[]],[[[41,[30,0,[\"isResettingPassword\"]],[[[1,\"                \"],[8,[39,5],[[24,0,\"u--inline u--p__l__xs\"]],[[\"@route\"],[\"login\"]],[[\"default\"],[[[[1,\"\\n                  \"],[1,[28,[35,3],[\"reset_password.login\"],null]],[1,\"\\n                \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"                \"],[1,[52,[30,0,[\"isSsoLogin\"]],[28,[37,3],[\"authorization.new_to_later_sso\"],[[\"ssoAppName\"],[[30,0,[\"ssoAppName\"]]]]],[28,[37,3],[\"authorization.new_to_later\"],null]]],[1,\"\\n\"],[41,[30,0,[\"isCampaign\"]],[[[1,\"                  \"],[8,[39,5],[[24,0,\"u--inline u--p__l__xs qa--createAccount_header_link\"]],[[\"@route\"],[\"campaign.signup\"]],[[\"default\"],[[[[1,\"\\n                    \"],[1,[28,[35,6],[[28,[37,3],[\"authorization.create_an_account\"],null]],null]],[1,\"\\n                  \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"                  \"],[8,[39,5],[[24,0,\"u--inline u--p__l__xs qa--createAccount_header_link\"]],[[\"@query\",\"@route\"],[[30,0,[\"searchParams\"]],\"signup\"]],[[\"default\"],[[[[1,\"\\n                    \"],[1,[28,[35,6],[[28,[37,3],[\"authorization.create_an_account\"],null]],null]],[1,\"\\n                  \"]],[]]]]],[1,\"\\n\"]],[]]],[1,\"              \"]],[]]]],[]]]],[]]],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[46,[28,[37,8],null,null],null,null,null],[1,\"\\n\\n  \"],[13],[1,\"\\n\"]],[]]]],[],false,[\"if\",\"and\",\"shared/link\",\"t\",\"on\",\"link-to\",\"html-safe\",\"component\",\"-outlet\"]]",
    "moduleName": "auth/templates/application.hbs",
    "isStrictMode": false
  });
});